export default __webpack_public_path__ + "static/media/17.f7e8eff9.svg";